let env = process.env.NODE_ENV

let CHECK_CODE = 'https://middleware.veloe.com.br/publico/campanhas'
let FC_FLOW_PRE_URL = 'https://veloe.com.br/planos/total-pre'
let FC_FLOW_POS_URL = 'https://veloe.com.br/planos/total-pos'
let FC_FLOW_ESTRADA_PRE_URL = 'https://veloe.com.br/planos/estrada-pre'
let FC_FLOW_CIDADE_PRE_URL = 'https://veloe.com.br/planos/planos/cidade-pre'
let WHITELIST_URL = 'https://middleware.veloe.com.br/publico/whitelist'
let VELOE_URL = 'https://veloe.com.br/sobre'

if (window.location.href) {
  if (window.location.href.indexOf('localhost') > -1) env = 'local'
  else if(window.location.href.indexOf('hml') > -1) env = 'hml'
  else if (window.location.href.indexOf('dev') > -1) env = 'dev'
}

if (env === 'local') {
  CHECK_CODE = 'http://localhost:3001/publico/campanhas'
  FC_FLOW_PRE_URL = 'http://localhost:3000/planos/total-pre'
  FC_FLOW_POS_URL = 'http://localhost:3000/planos/total-pos'
  FC_FLOW_ESTRADA_PRE_URL = 'https://localhost:3000/planos/estrada-pre'
  FC_FLOW_CIDADE_PRE_URL = 'https://localhost:3000/planos/planos/cidade-pre'
  WHITELIST_URL = 'http://localhost:3001/publico/whitelist'
  VELOE_URL = 'http://localhost:3000/sobre'
}
else if (env === 'dev') {
  CHECK_CODE = 'http://localhost:3001/publico/campanhas'
  FC_FLOW_PRE_URL = 'http://localhost:3000/planos/total-pre'
  FC_FLOW_POS_URL = 'http://localhost:3000/planos/total-pos'
  FC_FLOW_ESTRADA_PRE_URL = 'https://localhost:3000/planos/estrada-pre'
  FC_FLOW_CIDADE_PRE_URL = 'https://localhost:3000/planos/planos/cidade-pre'
  WHITELIST_URL = 'http://localhost:3001/publico/whitelist'
  VELOE_URL = 'http://localhost:3000/sobre'
} 
else if (env === 'hml') {
  CHECK_CODE = 'https://middleware.hml.fastalelo.com/publico/campanhas'
  FC_FLOW_PRE_URL = 'https://hml.fastalelo.com/planos/total-pre'
  FC_FLOW_POS_URL = 'https://hml.fastalelo.com/planos/total-pos'
  FC_FLOW_ESTRADA_PRE_URL = 'https://hml.fastalelo.com/planos/estrada-pre'
  FC_FLOW_CIDADE_PRE_URL = 'https://hml.fastalelo.com/planos/planos/cidade-pre'
  WHITELIST_URL = 'https://hml.fastalelo.com/publico/whitelist'
  VELOE_URL = 'https://hml.fastalelo.com/sobre'
}

export {
  CHECK_CODE,
  FC_FLOW_PRE_URL,
  FC_FLOW_POS_URL,
  FC_FLOW_ESTRADA_PRE_URL,
  FC_FLOW_CIDADE_PRE_URL,
  WHITELIST_URL,
  VELOE_URL,
}

export const getPlans = async (code) => {
  try {
  const pre = await fetch(`${CHECK_CODE}/${code}PRE`).then(res => res.json())
  const pos = await fetch(`${CHECK_CODE}/${code}POS`).then(res => res.json())
  const estrada = await fetch(`${CHECK_CODE}/${code}EST`).then(res => res.json())
  const cidade = await fetch(`${CHECK_CODE}/${code}CID`).then(res => res.json())

  if(!code.includes('RODOSOL')) {
    return {
      total: {
        pre: pre && pre[0] && pre[0].codPromocional ? pre[0] : null,
        pos: pos && pos[0] && pos[0].codPromocional ? pos[0] : null,
      },
      estrada: {
        pre: estrada && estrada[0] && estrada[0].codPromocional ? estrada[0] : null,
      },
      cidade: {
        pre: cidade && cidade[0] && cidade[0].codPromocional ? cidade[0] : null,
      }
    };
  };
  return {
    total: {
      pre: pre && pre[0] && pre[0].codPromocional ? pre[0] : null,
      pos: pos && pos[0] && pos[0].codPromocional ? pos[0] : null,
    }
  };
  }
  
  catch(e){
    /* return {
      pre: [{"numeroMesesBonificacao": CONFIG.DEFAULT_OFFER, "codPromocional": CONFIG.PROMO_CODE }][0],
      pos: [{"numeroMesesBonificacao": CONFIG.DEFAULT_OFFER, "codPromocional": CONFIG.PROMO_CODE}][0],
    } 
    */
  }
  return null
}